<template>
  <!-- 场景管理设置页面 -->
  <!-- 设置页面的内容区域 -->
  <div class="config_main_manage_page_wraper">
    <div class="config_main_manage_page_content">
      <!-- 设置页面  内容区域样式   以上部分都是公共样式 -->
      <config-title-hang class="config_hight_change_scene_manage">
        <span slot="config_title_hang_ele4">右击可删除一个场景</span>
        <img slot="config_title_hang_ele3"
             src="~assets/img/config/tishilaba.png"
             alt />
      </config-title-hang>

      <config-hang @click.native="configAddSceneBtnHandle">
        <span slot="config_hang_ele2">添加一个场景</span>
        <img slot="config_hang_ele4"
             src="~assets/img/config/youjiantou.png"
             alt />
      </config-hang>
      <config-title-hang>
        <span slot="config_title_hang_ele2">已有场景列表</span>
      </config-title-hang>

      <config-hang v-for="(value , index) in ServeSceneData"
                   :key="index"
                   @click.native="xiuGaiSceneBtnHandle(value)"
                   @contextmenu.prevent.native="oneSceneRightClickBtnHandle(value ,index )">
        <span slot="config_hang_ele2">{{value.sceneName}}</span>
        <span slot="config_hang_ele3">({{value.regionName}})</span>
        <img slot="config_hang_ele4"
             src="~assets/img/config/youjiantou.png"
             alt />
      </config-hang>
      <div class="xiaotishi_style">小提示：删除场景操作时，子账号尽量不要控制设备，否则可能出现删除场景失败的情况~。</div>

    </div>
  </div>
</template>

<script>
import configHang from 'components/common/config/config-hang'
import configTitleHang from 'components/common/config/config-title-hang'
export default {
  data () {
    return {
      ServeSceneData: [],
      OneSceneinfo: {
        deleteState: 1, ////是否显示 1显示 0不显示
        followState: null,
        iconId: '',
        iconUrl: '',
        regionId: '',
        regionName: '请选择一个区域',
        sceneId: '',
        sceneName: '',
        sceneNo: null
      }
    }
  },
  components: {
    configHang,
    configTitleHang
  },
  methods: {
    configAddSceneBtnHandle () {
      ///添加一个场景按钮
      ///需要先把仓库的一个场景的数据都给清空复原
      ////提交一个要修改的场景信息的地址到仓库（注意看上去是提交了一个地址，但其实是在提交过程中做了一个深度克隆，并不是提交地址）
      this.$store.dispatch('asyUpdataOneSceneinfo', this.OneSceneinfo)
      this.$router.push('/ConfigSceneMain/ConfigAddScene')
    },
    xiuGaiSceneBtnHandle (value) {
      this.$store.dispatch('asyUpdataOneSceneinfo', value)
      //代号 20231207-1
      this.$router.push({ path: '/ConfigSceneMain/ConfigAddScene', query: { title: '修改一个场景' } })
    },
    oneSceneRightClickBtnHandle (value, index) {
      ////一个场景管理的右击事件
      console.log('场景的右击事件')
      this.$showTipsToast(4, value, false, 1000, index)
    }
  },

  mounted () {
    console.log('mounted阶段')
  },
  created () {
    console.log('created阶段')
    /// 请求场景信息接口，获取数据
    this.$request({
      method: 'post',
      url: '/userScene/findUserSceneList',
      data: {
        token: this.$store.state.token
      }
    })
      .then(res => {
        if (res.data.code != 0) {
          this.$showTipsToast(3, res.data.message)
          ////说明信息填写错误,控制失败了，
          return
        } else {
          ////、控制成功了
          this.ServeSceneData = res.data.data ////拿到服务器返回的数据结果
          this.$store.dispatch('asyUpdataServeSceneData', this.ServeSceneData) ///异步提交信息到仓库
          // this.$showTipsToast(1, "获取成功", true); ////提示框
        }
      })
      .catch(error => {
        console.log(error)
      })
  }
}
</script>

<style>
.config_hight_change_scene_manage {
  height: 40px;
  line-height: 40px;
}
.config_hight_change_scene_manage img {
  right: 180px;
}
</style>